<script lang="ts">
    import type InstagramPostTagEntity from "@apps/instagram/entities/InstagramPostTagEntity";

    import Money from "@components/Money.svelte";
    import Tooltip from "@components/Tooltip/Tooltip.svelte";

    export let tag: InstagramPostTagEntity;
    export let selectedTagId: number | null = null;
    export let price: number | null = null;

    let title = tag.type === "product" ? tag.product.title : tag.link.title;
</script>

<Tooltip
    active={tag.id === selectedTagId && selectedTagId !== null}
    position="top"
    theme="light"
    arrow
>
    <div class="gw-ig-post-modal-viewer__tooltip-content">
        <p class="gw-ig-post-modal-viewer__tooltip-title gw-default-reset">
            {title}
        </p>
        {#if tag.type === "product" && price !== null}
            <span class="gw-ig-post-modal-viewer__tooltip-price">
                <Money amount={price} with_currency />
            </span>
        {/if}
    </div>
</Tooltip>

<style>
    .gw-ig-post-modal-viewer__tooltip-content {
        padding: 0.5em 1em;
    }
    .gw-ig-post-modal-viewer__tooltip-title {
        color: var(--gw-tooltip-light-title-color);
        line-height: 1.2em;
    }

    .gw-ig-post-modal-viewer__tooltip-price {
        color: var(--gw-tooltip-price-color);
        font-weight: bold;
    }
</style>
